import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(): IntegrityStatus {
    return [];
}
